<glxy-form-field class="input-chip-list" [bottomSpacing]="'none'" [formGroup]="formGroup">
  <glxy-label *ngIf="control.label">{{ control.label }}</glxy-label>
  <mat-chip-grid [formControl]="control" #chipList>
    <mat-chip-row *ngFor="let option of controlValue$ | async" [removable]="true" (removed)="remove(option)">
      {{ option | translate }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip-row>
    <input
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="control.separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="add($event)"
      autocomplete="off"
    />
  </mat-chip-grid>
</glxy-form-field>
